import { LoggerInterface } from './loggerModels';

export class NullLogger implements LoggerInterface {
  silly(message: string, attributes?: Object) {}
  trace(message: string, attributes?: Object) {}
  debug(message: string, attributes?: Object) {}
  info(message: string, attributes?: Object) {}
  warn(message: string, attributes?: Object) {}
  error(message: string, attributes?: Object) {}
  fatal(message: string, attributes?: Object) {}
  log(message: string, attributes?: Object) {}
  child(attributes: Object) {
    return this;
  }
}
